import axios from "axios";

// The Vertex client, compiled only into builds with trading. The condition sits at module level
// because inside an async function the transpiled state machine hides it from webpack, which then
// keeps the import (see next.config.js).
const loadVertexAxios = process.env.NEXT_PUBLIC_TRADING_ENABLED === "1" ? () => import("@/lib/vertex-axios") : null;

/**
 * End the TED (and, when signed in to trading, the Vertex) session.
 *
 * Lives here rather than in the sign-in component so the app shell (_app, the user menu) can sign
 * out without bundling the sign-in screen and the Amplify UI library into every page.
 */
export async function signOutFromBackend(vertexUser: string | null, ortexUser: string | null) {
    try {
        const ortexUrl = `${process.env.NEXT_PUBLIC_API_URL}/logout`;

        await axios.post(ortexUrl, ortexUser, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
            params: null,
        });

        // Only when the user has signed in to Vertex (trading); otherwise there is no session to end.
        // Builds without trading never sign in to Vertex.
        if (vertexUser && loadVertexAxios) {
            const { default: vertexAxios } = await loadVertexAxios();
            await vertexAxios.post("/logout"); // No body: Vertex ends the session the request carries.
        }
    } catch (error) {
        console.error("Error signing out from backend:", error);
    }
}
